module.exports = __webpack_public_path__ + "img/alfa.93e2a740.jpg";